/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class DimensionTenantSettings {
    getFixupPrototypeFunction() { return DimensionTenantSettings.fixupPrototype; }

    static newInstance(model: Partial<DimensionTenantSettings>): DimensionTenantSettings {
        let obj = Object.assign(new DimensionTenantSettings(), model);
        DimensionTenantSettings.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<DimensionTenantSettings>): DimensionTenantSettings {
        if (!model) return null;
        return DimensionTenantSettings.newInstance(<DimensionTenantSettings> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: DimensionTenantSettings) {
        if (!obj) return;

        models.DimensionTenantSettings.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: DimensionTenantSettings): boolean {
        Object.setPrototypeOf(obj, DimensionTenantSettings.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Name of the product
     */
    product: models.ProductEnum;

    /**
     * Mandate Dimension Selection
     */
    mandate_dimension_selection: boolean;

}
